import React from "react";
import { CONFIG } from "../../config/keys";
import axios from "axios";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { createNumberMask } from "redux-form-input-masks";
import uuid from "uuidv4";

import klerData from "../../apis/klerData";

const currencyMask = createNumberMask({
  prefix: "$",
  decimalPlaces: 2,
  locale: "en-US"
});

class GroupForm extends React.Component {
  render() {
    const updateGroup = formValues => {
      let updatedata = "";
      let name = "";
      if (formValues.Oid) {
        name = formValues.Name;
      } else {
        name = uuid();
      }
      updatedata += "{";
      updatedata += 'Name: "' + name + '",';
      if (formValues.Type) {
        updatedata += 'Type: "' + formValues.Type + '",';
      } else {
        updatedata += 'Type: "Product",';
      }
      if (formValues.HalfGramPrice && formValues.HalfGramPrice !== null) {
        updatedata += 'HalfGramPrice: "' + formValues.HalfGramPrice + '",';
      }
      if (formValues.GramPrice && formValues.GramPrice !== null) {
        updatedata += 'GramPrice: "' + formValues.GramPrice + '",';
      }
      if (formValues.EighthPrice && formValues.EighthPrice !== null) {
        updatedata += 'EighthPrice: "' + formValues.EighthPrice + '",';
      }
      if (formValues.QuarterPrice && formValues.QuarterPrice !== null) {
        updatedata += 'QuarterPrice: "' + formValues.QuarterPrice + '",';
      }
      if (formValues.HalfPrice && formValues.HalfPrice !== null) {
        updatedata += 'HalfPrice: "' + formValues.HalfPrice + '",';
      }
      if (formValues.OzPrice && formValues.OzPrice !== null) {
        updatedata += 'OzPrice: "' + formValues.OzPrice + '",';
      }
      if (formValues.SortOption) {
        updatedata +=
          'SortOption@odata.bind: "SortOption(' +
          parseInt(formValues.SortOption) +
          ')",';
      } else {
        updatedata += 'SortOption@odata.bind: "SortOption(1)",';
      }
      updatedata += 'SubscriptionId: "' + formValues.SubscriptionId + '"';
      updatedata += "}";
      //console.log(updatedata);
      if (formValues.Oid) {
        // **************************
        // UPDATE RECORD
        const EditGroupQuery = "/Group(" + parseInt(formValues.Oid) + ")";
        axios({
          method: "put",
          url: CONFIG.API_URL + EditGroupQuery,
          data: updatedata,
          headers: {
            "Content-Type": "application/json",
            Auth: CONFIG.API_KEY
          }
        })
          .then(result => {
            this.props.handleCloseReload();
          })
          .catch(error => console.log(error));
      } else {
        // **************************
        // CREATE GROUP
        klerData
          .post(`/Group`, updatedata)
          .then(result => {
            selectNewRecord();
          })
          .catch(error => console.log(error));

        // **************************
        // SELECT NEW GROUP
        const selectNewRecord = () => {
          klerData
            .get(
              `/Group?$filter=Name eq '${name}'&$select=Oid,Name&$format=json`
            )
            .then(result => {
              console.log(result.data.d[0]);
              createMenuItem(result.data.d[0]);
            })
            .catch(error => console.log(error));
        };

        // **************************
        // CREATE MENU ITEM
        const createMenuItem = data => {
          let menudata = "";
          menudata = menudata + "{";
          menudata = menudata + `GroupToShow@odata.bind: "Group(${data.Oid})",`;
          menudata = menudata + `Name: "${formValues.Name}",`;
          menudata = menudata + `Type: "Group",`;
          menudata =
            menudata + `SubscriptionId: "${formValues.SubscriptionId}"`;
          menudata = menudata + "}";
          // console.log(menudata);
          klerData
            .post(`/MenuItems`, menudata)
            .then(result => {
              updateName(data);
            })
            .catch(error => console.log(error));
        };

        // **************************
        // UPDATE GROUP NAME
        const updateName = data => {
          klerData
            .put(`/Group(${data.Oid})`, {
              Name: formValues.Name
            })
            .then(result => {
              this.props.handleCloseReload();
            })
            .catch(error => console.log(error));
        };
      }
    };
    const renderSortOptions = () => {
      return this.props.sortOptions.map((record, index) => {
        return (
          <option key={"sort-" + index} value={record.Oid}>
            {record.Name}
          </option>
        );
      });
    };
    const onSubmit = formValues => {
      // console.log(formValues);
      updateGroup(formValues);
    };
    return (
      <div className="txt-center">
        <h4>Group</h4>
        <form
          onSubmit={this.props.handleSubmit(onSubmit)}
          className={"show-" + this.props.data.Type + "-pricing"}
        >
          <div>
            <Field
              name="Oid"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="SubscriptionId"
              component="input"
              type="hidden"
              autoComplete="off"
            />
          </div>
          <div>
            <label>Group Name</label>
            <div>
              <Field
                name="Name"
                component="input"
                type="text"
                placeholder="Group Name"
                autoComplete="off"
              />
            </div>
          </div>
          <div>
            <label>Sort Products By</label>
            <Field name="SortOption" component="select">
              <option value="1">Name</option>
              {renderSortOptions()}
            </Field>
          </div>
          <div>
            <label>Pricing Display</label>
            <Field name="Type" component="select">
              <option value="Product">
                Display Product Pricing (Group Pricing Hidden)
              </option>
              <option value="Group">
                Display Group Price (Product Pricing Hidden)
              </option>
            </Field>
          </div>
          <div className="group-price">
            <label>Half Gram Price</label>
            <div>
              <Field
                name="HalfGramPrice"
                component="input"
                type="text"
                placeholder="Half Gram Price"
                autoComplete="off"
                {...currencyMask}
              />
            </div>
          </div>
          <div className="group-price">
            <label>Gram Price</label>
            <div>
              <Field
                name="GramPrice"
                component="input"
                type="text"
                placeholder="Gram Price"
                autoComplete="off"
                {...currencyMask}
              />
            </div>
          </div>
          <div className="group-price">
            <label>Eighth Price</label>
            <div>
              <Field
                name="EighthPrice"
                component="input"
                type="text"
                placeholder="Eighth Price"
                autoComplete="off"
                {...currencyMask}
              />
            </div>
          </div>
          <div className="group-price">
            <label>Quarter Price</label>
            <div>
              <Field
                name="QuarterPrice"
                component="input"
                type="text"
                placeholder="Quarter Price"
                autoComplete="off"
                {...currencyMask}
              />
            </div>
          </div>
          <div className="group-price">
            <label>Half Price</label>
            <div>
              <Field
                name="HalfPrice"
                component="input"
                type="text"
                placeholder="Half Price"
                autoComplete="off"
                {...currencyMask}
              />
            </div>
          </div>
          <div className="group-price">
            <label>Oz Price</label>
            <div>
              <Field
                name="OzPrice"
                component="input"
                type="text"
                placeholder="Oz Price"
                autoComplete="off"
                {...currencyMask}
              />
            </div>
          </div>
          <button className="waves-effect waves-light btn btn-small">
            Submit
          </button>
          &nbsp;
          <button
            type="button"
            className="waves-effect waves-light btn btn-small"
            onClick={this.props.handleClose}
          >
            Cancel
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // **************************
  // FIX REFERENCE LINK FIELDS
  let initVals = [];
  if (ownProps.data.SortOption) {
    initVals.SortOption = ownProps.data.SortOption.Oid;
  } else {
    initVals.SortOption = "1";
  }

  return {
    initialValues: {
      Oid: ownProps.data.Oid,
      Name: ownProps.data.Name,
      SubscriptionId: ownProps.SubscriptionId,
      Type: ownProps.data.Type,
      SortOption: initVals.SortOption,
      HalfGramPrice: ownProps.data.HalfGramPrice,
      GramPrice: ownProps.data.GramPrice,
      EighthPrice: ownProps.data.EighthPrice,
      QuarterPrice: ownProps.data.QuarterPrice,
      HalfPrice: ownProps.data.HalfPrice,
      OzPrice: ownProps.data.OzPrice
    },
    sortOptions: ownProps.sortOptions
  };
};

const validate = formValues => {
  const errors = {};

  if (!formValues.Name) {
    errors.Name = "Please enter a group name";
  }

  return errors;
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "GroupForm",
    validate
  })(GroupForm)
);
